import { requestApi } from "../funcitons";

export default {
    // ============ PRODUCTS ============
    getAll: async (project_id) => {
        const res = await requestApi(`products/${project_id}`, 'GET');
        return res.data;
    },
    getById: async (id) => {
        const res = await requestApi(`products/${id}`, 'GET');
        return res.data;
    },
    create: async (data) => {
        const res = await requestApi('products', 'POST', data);
        return res.data;
    },
    update: async (id, data) => {
        const res = await requestApi(`products/${id}`, 'PUT', data);
        return res.data;
    },
    delete: async (id) => {
        const res = await requestApi(`products/${id}`, 'DELETE');
        return res.data;
    },

    // ============ CATEGORIES ============
    getAllCategories: async (project_id) => {
        const res = await requestApi(`products/categories/${project_id}`, 'GET');
        return res.data;
    },
    createCategory: async (name, description, project_id) => {
        const res = await requestApi('products/categories', 'POST', { name, description, project_id });
        return res.data;
    },
    updateCategory: async (id, name, description) => {
        const res = await requestApi(`products/categories/${id}`, 'PUT', { name, description });
        return res.data;
    },
    deleteCategory: async (id) => {
        const res = await requestApi(`products/categories/${id}`, 'DELETE');
        return res.data;
    },
    linkProductToCategory: async (product_category_id, product_id) => {
        const res = await requestApi(`products/categories/${product_category_id}/products/${product_id}`, 'POST');
        return res.data;
    },
    unlinkProductFromCategory: async (product_category_id, product_id) => {
        const res = await requestApi(`products/categories/${product_category_id}/products/${product_id}`, 'DELETE');
        return res.data;
    },

    // ============ IMAGES ============
    createImage: async (product_id, image_url) => {
        const res = await requestApi('products/images', 'POST', { product_id, image_url });
        return res.data;
    },
    deleteImage: async (id) => {
        const res = await requestApi(`products/images/${id}`, 'DELETE');
        return res.data;
    },
    setDefaultImage: async (product_id, image_id) => {
        const res = await requestApi(`products/${product_id}/default-image`, 'PUT', { image_id });
        return res.data;
    },

    // ============ PRICES ============
    createPrice: async (product_id, price) => {
        const res = await requestApi('products/prices', 'POST', { product_id, price });
        return res.data;
    },
    setDefaultPrice: async (product_id, price_id) => {
        const res = await requestApi(`products/${product_id}/default-price`, 'PUT', { price_id });
        return res.data;
    },

    // ============ ALLERGENS ============
    getAllAllergens: async () => {
        const res = await requestApi('products/allergens/all', 'GET');
        return res.data;
    },
    getProductAllergens: async (product_id) => {
        const res = await requestApi(`products/allergens/${product_id}`, 'GET');
        return res.data;
    },
    linkAllergenToProduct: async (product_id, allergen_id) => {
        const res = await requestApi(`products/allergens/${product_id}/${allergen_id}`, 'POST');
        return res.data;
    },
    unlinkAllergenFromProduct: async (product_id, allergen_id) => {
        const res = await requestApi(`products/allergens/${product_id}/${allergen_id}`, 'DELETE');
        return res.data;
    },
    syncProductAllergens: async (product_id, allergen_ids) => {
        const res = await requestApi(`products/allergens/${product_id}/sync`, 'PUT', { allergen_ids });
        return res.data;
    },
};

